import { Typography } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { defaultProficiencyFeedbackValues } from "../../../ProficiencyFeedbackForm.default";

const PotentialNonConformitiesFormText = withForm({
  defaultValues: defaultProficiencyFeedbackValues,
  props: { readonly: false },
  render: ({ form, readonly }) => {
    return (
      <>
        <Typography>
          Unsatisfactory participation in any NVLAP proficiency testing program
          result in NVLAP nonconformities that must be resolved in order to
          obtain initial accreditation or maintain accreditation. (See NVLAP
          Handbook 150-20:2014 section 3.4)
        </Typography>

        <Typography>
          {`Do `}
          <Typography
            component="span"
            sx={{ textDecoration: "underline" }}
            fontWeight={"bold"}
          >
            NOT
          </Typography>
          {` include proprietary information in potential non-conformity or comment
          descriptions:`}
        </Typography>

        <form.AppField name="potentialNonConformities">
          {(field) => (
            <field.HtmlEditor
              label="Potential Non-Conformities"
              required={true}
              disabled={readonly}
            />
          )}
        </form.AppField>
      </>
    );
  },
});

export default PotentialNonConformitiesFormText;
